var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtube-player"},[_c('div',{ref:"youtubePlayer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }